import {Component, Event, EventEmitter, h, Host, Prop, State} from "@stencil/core";
import {NestDatePickerHeader} from "../components/nest-date-picker-header";
import {NestDatePickerChangeView} from "../nest-date-picker.interfaces";
import moment, {Moment} from "moment";

@Component({
  tag: 'nest-date-picker-decade',
  styleUrl: '../nest-date-picker.scss',
  shadow: true
})
export class NestDatePickerDecadeView {
  @State() rows: any[] = [];
  @State() headerLabel: string;
  @State() headerDisabled = {};

  @Prop({ mutable: true }) activeDate: Moment;
  @Prop({ mutable: true }) selectedDate: Moment;

  @Prop() minDate: Moment;
  @Prop() maxDate: Moment;

  @Event() changeView: EventEmitter<NestDatePickerChangeView>;

  private generateView(): void {
    const date: number = (this.activeDate || this.selectedDate).year();

    let startDecade: number = this.getDecade(date) - 5 * 10;
    let endDecade: number = startDecade + 11 * 10;

    const minDecade = this.getDecade(this.minDate && this.minDate.year());
    const maxDecade = this.getDecade(this.maxDate && this.maxDate.year());

    if (maxDecade && endDecade > maxDecade) {
      endDecade = maxDecade;
      startDecade = endDecade - 11 * 10;
    }
    if (minDecade && startDecade < minDecade) {
      startDecade = minDecade;
      endDecade = startDecade + 11 * 10;
    }

    this.headerDisabled = {
      prev: minDecade && startDecade <= minDecade,
      next: maxDecade && endDecade >= maxDecade
    }

    this.activeDate = moment([startDecade]);

    let decade: number = startDecade;

    this.rows = [];
    for (let index = 0; index < 12; index++) {
      let column: number = Math.floor(index / 3);

      if(!this.rows[column]) this.rows[column] = [];
      this.rows[column].push({
        id: decade,
        label: this.getDecadeLabel(decade),
        current: this.isDecade(moment(), decade),
        selected: this.isDecade(this.selectedDate, decade),
        disabled: minDecade && decade < minDecade || maxDecade && decade > maxDecade
      })
      decade += 10;
    }
    this.headerLabel = this.getDecadeLabel(startDecade, endDecade)
  }

  componentWillLoad() {
    this.generateView()
  }

  componentWillUpdate() {
    this.generateView()
  }

  private choose(decade: {id: number, label: string}): void {
    this.activeDate = moment([decade.id])
    this.changeView.emit({ view: 'year', answer: this.activeDate});
  }

  private next(): void {
    this.activeDate.add(12 * 10, 'years')
    this.generateView()
  }

  private prev(): void {
    this.activeDate.subtract(12 * 10, 'years')
    this.generateView()
  }

  private getDecade(year: number): number {
    return year && Math.floor(year / 10) * 10;
  }

  private getDecadeLabel(decade: number, endDecade?: number): string {
    return endDecade ? `${decade} - ${endDecade + 9}` : `${decade} - ${decade + 9}`
  }

  private isDecade(date: Moment, decade: number): boolean {
    return date && this.getDecade(date.year()) === decade;
  }

  render() {
    return (
      <Host>
        <NestDatePickerHeader
          actions={[{ label: this.headerLabel, disabled: true }]}
          nextHandler={this.next.bind(this)}
          prevHandler={this.prev.bind(this)}
          disabled={this.headerDisabled}
        />

        {this.rows.map(row => (
          <div class='flex flex-wrap mb-3'>
            { row.map((item) => (
              <button
                onClick={() => this.choose(item)}
                disabled={item.disabled}
                type="button"
                class={{
                  'datepicker-month__item': true,
                  'bg-gray-100': !item.selected && item.current,
                  'bg-blue-600 text-white': item.selected,
                  'disabled:text-gray-300 disabled:cursor-default': item.disabled
                }}>
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </Host>
    )
  }
}
